export default __webpack_public_path__ + "static/media/movipack_feature2hover.e1dcbba7.svg";